module.exports = __webpack_public_path__ + "media/favicon/mstile-150x150-90a462e8853c6a73cee6d5a5e4c78b1b.png";